const img = require('./porchSideC_active.svg'); export default img;